import muteSound from '../assets/mute.svg';
import cat from '../assets/animals/cat.png';
import dino from '../assets/animals/dino.png';
import giraffe from '../assets/animals/giraffe.png';
import goat from '../assets/animals/goat.jpg';
import panda from '../assets/animals/panda.jpg';
import snake from '../assets/animals/snake.jpg';
import rhino from '../assets/animals/rhino.png';
import tiger from '../assets/animals/tiger.jpg';
import frozen1 from '../assets/frozen/frozen1.png';
import frozen2 from '../assets/frozen/frozen2.png';
import frozen3 from '../assets/frozen/frozen3.png';
import frozen4 from '../assets/frozen/frozen4.png';
import frozen5 from '../assets/frozen/frozen5.png';
import frozen6 from '../assets/frozen/frozen6.png';
import frozen7 from '../assets/frozen/frozen7.png';
import frozen8 from '../assets/frozen/frozen8.png';
import frozen9 from '../assets/frozen/frozen9.png';

export const animals = {
  cat,
  dino,
  giraffe,
  goat,
  panda,
  snake,
  rhino,
  tiger,
  muteSound,
};

export const frozen = {
  frozen1,
  frozen2,
  frozen3,
  frozen4,
  frozen5,
  frozen6,
  frozen7,
  frozen8,
  frozen9,
};
